import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { useCallback } from 'react';
import AnimateHeight from 'react-animate-height';
import { useDispatch, useSelector } from 'react-redux';

import { Button, ButtonVariant } from 'gcs-common/design-system/ui/button';
import { getChannelInputShowSuggestions } from 'gcs-common/slices/messageInput/messageInputSelector';
import { changeInputText } from 'gcs-common/slices/messageInput/messageInputThunks/changeInputText';

const suggestions = [
  {
    text: 'Ich bin dran. Ich geb dir Bescheid wenn ich mehr weiß.',
    message: 'Ich bin dran. Ich geb dir Bescheid wenn ich mehr weiß.',
  },
];

const MessageSuggestions = () => {
  const selectedChannelId = useSelector(getSelectedChannelId);
  const showSuggestions = useSelector(getChannelInputShowSuggestions(selectedChannelId));
  const dispatch = useDispatch();

  const onMessageChanged = useCallback(
    (text) => () => {
      dispatch(changeInputText({ channelId: selectedChannelId, inputText: text }));
    },
    [dispatch, selectedChannelId],
  );

  return (
    <AnimateHeight className="flex-1" height={showSuggestions ? 'auto' : 0} duration={300}>
      {suggestions.map((suggestion) => (
        <Button
          variant={ButtonVariant.soft_neutral}
          key={suggestion.text}
          onClick={onMessageChanged(suggestion.message)}
          className="rounded-bl-none text-xs"
        >
          {suggestion.text}
        </Button>
      ))}
    </AnimateHeight>
  );
};

export default MessageSuggestions;
